import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";

// GET /api/portal/mdf/attachments/:id/signed-url — short-lived (1h) signed
// download URL. One-shot mutation: called only on click of an attachment
// row in the read-only detail view, so we don't ever cache the URL (each
// download mint a fresh one).

type Response = { url: string; file_name: string };

export function useMdfAttachmentUrl() {
  return useMutation<Response, ApiClientError, { id: string }>({
    mutationFn: ({ id }) =>
      apiFetch<Response>(`/portal/mdf/attachments/${id}/signed-url`),
    onError: (err) => {
      toast.error(err.message ?? "Failed to prepare download");
    },
  });
}
